import React, { useState } from 'react';
import useProxyAuthWithWebToken from '../hooks/useProxyAuthWithWebToken';
import {
  Backdrop,
  CircularProgress,
  IconButton,
  Typography
} from '@mui/material';
import { ErrorCodes } from '../types';
import { RouteComponentProps } from 'react-router';
import Layout from '../components/Layout';
import { useTranslation } from 'react-i18next';
import DocsPrivacyDomRF from '../components/DocsPrivacyDomRF';
import AgreementFormDomRF from '../components/AgreementFormDomRF';
import Alert from '@mui/lab/Alert';
import ClearIcon from '@mui/icons-material/Clear';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}));
/**
 * Main Page
 */
export default function(
  props: RouteComponentProps<{
    webToken: string;
    internalUrl: string;
    [key: number]: string;
  }>
) {
  const { response } = useProxyAuthWithWebToken({
    webToken: props.match.params.webToken,
    internalUrl: props.match.params.internalUrl || props.match.params[0]
  });
  const language = 'ru';
  const classes = useStyles();
  const { t } = useTranslation();
  const [notFoundError, setNotFoundError] = useState('');

  let content = (
    <div>
      <Typography component="h1" variant="h5" align="center">
        {t('loginHeader')}
      </Typography>
      {!notFoundError && (
        <Backdrop className={classes.backdrop} open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </div>
  );
  if (
    response &&
    response.error &&
    response.error.code === ErrorCodes.NOT_SIGNED_AGREEMENT
  ) {
    content = (
      <AgreementFormDomRF
        webToken={props.match.params.webToken}
        internalUrl={props.match.params.internalUrl || props.match.params[0]}
        label={'Я согласен на обработку персональных данных'}
      >
        <DocsPrivacyDomRF lng={language || 'en'} />
      </AgreementFormDomRF>
    );
  } else {
    if (response && response.error) {
      if (response.error.code !== ErrorCodes.UNAUTHORIZED_USER) {
        switch (response.error.code) {
          case ErrorCodes.USER_NOT_FOUND:
            let code = t(response.error.error) ?? t('notFound');
            setNotFoundError(code);
            break;
          case ErrorCodes.INVALID_PASSWORD:
            setNotFoundError(t('wrongCredentials'));
            break;
          default:
            setNotFoundError(t('error'));
            break;
        }
      }
    }
  }

  return (
    <Layout maxWidth="lg" showFooter={false} showHeader={false}>
      <div>{content}</div>
      {notFoundError && (
        <Alert
          severity="error"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setNotFoundError('');
              }}
            >
              <ClearIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {notFoundError}
        </Alert>
      )}
    </Layout>
  );
}
